import { useEffect } from "react";
import { useAppState } from "../state/App";
import { useMatch, useNavigate } from "react-router-dom";
import { RouteNames } from "../RouteNames";

export function KioskPage() {
  const match = useMatch(RouteNames.KIOSK);
  const {
    actions: { setIsKiosk, setModeId },
  } = useAppState();
  const navigate = useNavigate();

  useEffect(() => {
    const modeId = match?.params.modeId;
    const isExitMode = modeId === "exit";

    setIsKiosk(!isExitMode);
    if (modeId) {
      setModeId(modeId);
    }
  }, [match, setIsKiosk, setModeId]);

  useEffect(() => {
    // Only navigate after state has been updated
    navigate("/", { replace: true });
  }, [navigate]);

  return null;
}
